module.exports = __webpack_public_path__ + "img/logo_center_white.8bab2d4d.svg";